/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mobilePhone[_ngcontent-%COMP%]{margin-bottom:10px;margin-top:0;margin-left:-4px;-ms-flex-align:center;align-items:center;justify-items:center;display:-ms-flexbox;display:flex}.checkboxLabel[_ngcontent-%COMP%]{color:#565656;font-family:Roboto,sans-serif;font-size:11px;font-weight:500}"];
export { styles as styles };
